import React, { useMemo } from 'react';
import cn from 'classnames';

import Img from 'components/presenters/Img/Img';
import { getDefaultImagePath } from 'utils';

import styles from './Image.module.scss';

type Props = {
  title: string;
  staticAssetsUrl: string;
  isLandscapeRatio?: boolean;
  image?: string;
};

export const Image = ({ title, isLandscapeRatio, image, staticAssetsUrl }: Props) => {
  const fallbackImage = useMemo(() => `${staticAssetsUrl}${getDefaultImagePath(isLandscapeRatio)}`, [
    isLandscapeRatio,
    staticAssetsUrl,
  ]);
  return (
    <div
      className={cn(styles.wrapper, {
        [styles.wrapperPortrait]: !isLandscapeRatio,
      })}
    >
      <div>
        <Img alt={title} src={image!} fallbackImage={fallbackImage} />
      </div>
    </div>
  );
};
